var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditRequestIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2298",
    "data-name": "Group 2298",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M4.667,8.417a.917.917,0,0,1,.917.917,6.389,6.389,0,0,1,3.969,1.375h1.989a4.116,4.116,0,0,1,3.075,1.375H17.5A4.583,4.583,0,0,1,21.64,14.7,12.058,12.058,0,0,1,12,19.417,13.243,13.243,0,0,1,5.528,17.9a.915.915,0,0,1-.862.6H1.917A.917.917,0,0,1,1,17.583V9.333a.917.917,0,0,1,.917-.917Zm.918,2.75v4.6l.041.029A10.905,10.905,0,0,0,12,17.583a10.3,10.3,0,0,0,7.182-2.869l.122-.122-.11-.092a2.745,2.745,0,0,0-1.506-.577l-.188-.006H15.565a4.193,4.193,0,0,1,.1.917v.917H7.417V13.917h6.224l-.031-.072a2.293,2.293,0,0,0-1.918-1.3l-.15,0H8.856a4.57,4.57,0,0,0-3.271-1.375ZM3.75,10.25H2.833v6.417H3.75Zm12.833-5.5a2.75,2.75,0,1,1-2.75,2.75A2.75,2.75,0,0,1,16.583,4.75Zm0,1.833A.917.917,0,1,0,17.5,7.5.917.917,0,0,0,16.583,6.583ZM10.167,2a2.75,2.75,0,1,1-2.75,2.75A2.75,2.75,0,0,1,10.167,2Zm0,1.833a.917.917,0,1,0,.917.917A.917.917,0,0,0,10.167,3.833Z",
    transform: "translate(-0.083 -0.167)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditRequestIcon);
export default __webpack_public_path__ + "static/media/credit-request-icon.4140465b06acb74c0ab8624b09928e09.svg";
export { ForwardRef as ReactComponent };